<template>
  <button :type="type" v-bind="$props" :style="style" :class="classes" @click="e => $emit('click',classes)">
     <slot></slot>
     {{ label }}
   </button>
</template>

<script>
export default {
   name: 'Button',
   props: {
      label: {
         type: String,
      },
      type: {
         type: String,
         default: 'button',
         validator: value => ["button", "submit", "reset"].includes(value),
      },
      color: {
         type: String,
         default: 'primary',
         validator: value => ['primary', 'success', 'info', 'light', 'danger'].includes(value),
      },
      size: {
         type: String,
         default: 'medium',
         validator: value => ["large", "medium", "small"].includes(value),
      },
      backgroundColor: {
         type: String,
      },
      fullWidth: {
         type: Boolean
      }
   },
   computed: {
      classes() {
         return {
            [this.color]: true,
            [`${this.size}`]: true,
            'w-100': this.fullWidth,
         }
      },
      style() {
         return {
            backgroundColor: this.backgroundColor,
         }
      }
   }
}
</script>

<style lang="scss" scoped>

@mixin setTheme($color, $background-color)
{
   border: 1px solid transparent;
   color: $color;
   background-color: $background-color;
   @if lightness($background-color) > 75%
   {
      border-color: darken($background-color, 20%);
   }

   &:hover {
      background-color: darken($background-color, 2%);
      border-color: darken($background-color, 10%);
      @if lightness($background-color) > 75%
      {
         border-color: darken($background-color, 30%);
      }
      box-shadow: inset 0 0px 2px rgba(0,0,0,.1),
         0 0 3px rgba(255,255,255,0.9);
   }
   &:focus {
      border-color: darken($background-color, 20%);
      box-shadow: none;
   }
   &:active {
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15) inset;
   }
   &:disabled {
      background: lighten($background-color, 5%);
      cursor: not-allowed; 
      color: rgb(168, 168, 168);
   }
}

button {
   font-family: $primary-font;
   color: #fff;
   font-weight: 400;
   border-radius: $border-radius;
   outline: none;
   margin-bottom: 15px;
   display: block;
   margin: 10px 0px;
   box-shadow: 0 0 2px rgba(0,0,0,0.1);
   cursor: pointer;
   padding: 0.4em 0.8em;
   
   &.primary   { @include setTheme( $light-color, $primary-color );   }
   &.secondary { @include setTheme( $light-color, $secondary-color ); }
   &.success   { @include setTheme( $light-color, $success-color );   }
   &.info      { @include setTheme( $light-color, $info-color );      }
   &.light     { @include setTheme( $font-color,  $light-color );     }
   &.dark      { @include setTheme( $light-color, $dark-color );      }
   &.danger    { @include setTheme( $light-color, $danger-color );    }
}

.small {
   font-size: 0.8em;
}
.medium {
   font-size: 0.9em;
}
.large {
   font-size: 1em;
}
.w-100 {
   width: 100%;
}
</style>